"use client";

import Image from "next/image";
import { Fragment, useState } from "react";
import {
  PreviewImage,
  ProductImageWrapper,
  ImageContainer
} from "./styles";
import { calculateDiscount } from "lib";
import DiscountChip from "components/product-cards/discount-chip";

export default function ProductGallery({
  images,
  discount_percentage = 0,
  defaultImage
}) {
  const [currentImage, setCurrentImage] = useState(0);

  return (
    <Fragment>
      <ProductImageWrapper>
        {discount_percentage !== 0 && (
          <div className="chip-container">
            <DiscountChip discount={discount_percentage} />
          </div>
        )}

        <div className="image-box">
          <Image
            fill
            alt="product"
            src={images.length === 0 ? defaultImage : images[currentImage]}
            sizes="(max-width: 768px) 100vw, 400px"
            style={{ objectFit: "contain" }}
          />
        </div>
      </ProductImageWrapper>

      <div className="preview-images">
        {images.map((url, ind) => (
          <PreviewImage
            key={ind}
            onClick={() => setCurrentImage(ind)}
            selected={currentImage === ind}
          >
            <Image
              fill
              alt="product"
              src={url}
              sizes="(max-width: 48px) 100vw, 48px"
              style={{ objectFit: "cover" }}
            />
          </PreviewImage>
        ))}
      </div>
    </Fragment>
  );
}
